module.exports = __webpack_public_path__ + "img/OBCINA DOL PRI LJUBLJANI.500b304a.png";